
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("principalToken");

  if (!token) {
    return <Navigate to="/principal-login" />;
  }

  return children;
};

export default ProtectedRoute;